import React from 'react';
import { createRoot } from 'react-dom/client';
import { AssistantConfigWindow } from '../../types';
import { App } from './app';

declare let window: AssistantConfigWindow;

window.assistantConfig = window.assistantConfig || {};

const init = () => {
  // timeout makes sure that the app is loaded before the chat app mounts
  setTimeout(() => {
    const root = document.createElement('div');
    root.setAttribute('id', 'assistant-webchat-root');
    document.body.appendChild(root);
    const rootContainer = document.getElementById('assistant-webchat-root');
    const embeddedChatRoot = createRoot(rootContainer);
    embeddedChatRoot.render(<App />);
  }, 1000);
};

init();
